var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgEmailSent = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M15.85 48.158c-2.556 1.34-2.45 3.305.23 4.365l7.94 3.142c2.683 1.065 6.742.484 9.015-1.29l34.482-27.193c2.266-1.783 2.51-1.52.54.588L40.8 56.947c-1.975 2.1-1.392 4.681 1.299 5.722l.93.362a738.936 738.936 0 0 1 9.75 3.875l8.806 3.586c2.676 1.087 5.535-.194 6.295-2.978L81.3 18.179c.758-2.784-.714-3.966-3.27-2.627L15.85 48.158Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M37.642 80.457c-.157.47 5.43-8.091 5.43-8.091 1.58-2.413.683-5.292-1.986-6.383l-6.093-2.494c-2.67-1.092-3.948.19-2.844 2.856 0 0 5.654 13.628 5.493 14.112Z"
  }));
};
export default SvgEmailSent;